import React, { Component } from "react";
import {Link, withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import {FormattedMessage} from 'react-intl'
import HtmlSection from './htmlsection';
import * as wConsts from '../consts/website-consts';
import BuyAdBanner from "./buyadbanner";
import SeoHeaders from "./seoheaders";
import * as wActs from "../actions/website-actions";
import SwBanner from "./swbanner";
import SsrBanner from "./ssrbanner";

class Footer extends Component {

  handleClick(e) {
    window.scrollTo(0, 0)
  }

  getRequestInfo() {
    if(this.props.WebPage.Request) {
      let req = this.props.WebPage.Request;
      return (<span>{req.IpAddress} - [{req.CountryCode}]</span>)
    } else {
      return null;
    }
  }


  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.reload(true) //Force cache update fuckers
  }

  render() {
    let tmp = this.props.Template;
    let acc = "";
    if(!wActs.isNullOrUndefined(tmp)) {
      if(!wActs.isNullOrUndefined(tmp.Country) && !wActs.isNullOrEmpty(tmp.Country.Code)) {
        acc=tmp.Country.Code;
      }
    }

    let isAdult = wActs.isAdult(this.props.WebPage);

    return (
      <React.Fragment>
        <div className="clear"></div>




        <div className="clear"></div>

        <div style={{display: "flex", justifyContent: "center", paddingBottom: "15px"}}><HtmlSection Id={"RedlightDistrictLink"}/></div>
        <div style={{display: "flex", justifyContent: "center", paddingBottom: "15px"}}><HtmlSection Id={"DMCA"}/></div>

        <footer>
          <div className="container">
            <div className="footer-menu">
              <nav>
                <ul>
                  {this.props.WebPage.Menu.Footer.map((v,i) => {
                    if(v.Page) {
                      return <li key={"mnuli-1-" + i}><Link className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description}>{v.Title}</Link></li>;
                    } else {
                      if(v.Settings) {
                        return <li key={"mnuli-1-" + i}><a className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} href={v.Settings.Url} title={v.Description} target={"_blank"}>{v.Title}</a></li>;
                      }
                    }
                    return null;
                  })}

                </ul>
              </nav>
            </div>

            {(!wActs.isNullOrUndefined(this.props.WebPage.Page.Content.LiabilityWarning)) &&
            <p className="copyright" style={{margin: "20px auto", maxWidth: "850px"}}><span>{this.props.WebPage.Page.Content.LiabilityWarning}</span></p>
            }

            <p className="copyright"><FormattedMessage id={"page.footer.copyright"} /></p>

            {isAdult && <p className="copyright"><FormattedMessage id={"page.footer.allmodelslistedwarning"}/></p>}

            {this.props.WebPage.Settings.ShowVersionFooter &&
              <p className="copyright"><FormattedMessage id={"page.footer.version"}/> - [<a onClick={(e) => {this.handleRefresh(e)}} style={{color: "#fff", cursor: 'pointer', fontSize: "12px", textTransform: 'none'}}><FormattedMessage id={"page.refresh"}/></a>]</p>
            }
            {(this.props.WebPage.Settings.ShowCompanyInfoInFooter && !wActs.isNullOrUndefined(this.props.WebPage.Page.Content.CompanyInfoFooter)) &&
              <p className="copyright">{this.props.WebPage.Page.Content.CompanyInfoFooter}</p>
            }

          </div>
        </footer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Template: state.Website.Page.Template

  };
}

export default connect(mapStateToProps)(Footer);
